import { HttpErrorResponse } from '@angular/common/http';

/**
 * The router state for a redirect to the inactive-request page.
 *
 * Router state is written to `history.pushState`, which structured-clones it. Since KOR-15073 the
 * error interceptor passes a rejection that names an `errorCode` through as the whole
 * HttpErrorResponse, and its HttpHeaders hold a lazy-init closure that cannot be cloned: the
 * navigation throws DataCloneError and the customer is left on the failed step. Only that response
 * is reduced - to its status and body, which are what the pages read (the linx-v1 page reads
 * `error.code` from the body). A status string, a number or a plain object clones as it is.
 */
export const inactiveRequestState = (error: unknown): { error: unknown } => ({
  error: error instanceof HttpErrorResponse ? { status: error.status, error: error.error } : error,
});
